<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div class="scrolled">

        <mat-tab-group mat-stretch-tabs [selectedIndex]="selectedIndex" (selectedIndexChange)="setShippingModeByIndex($event)">

            <mat-tab label="First" *ngFor="let mode of shippingDatas">

                <ng-template mat-tab-label>
                    <span>{{mode.name}}</span>
                </ng-template>

                <div fxLayout="column" fxLayoutGap="10px" class="layout-padd">

                    <div fxLayout="column" fxLayoutGap="10px" class="bordered-card layout-padd">

                        <div fxLayoutAlign="center center">
                            <img matPrefix src="data:image/png;base64,{{currCountry.flag}}"  class="h-10" *ngIf="currCountry">
                            <img matPrefix src="assets/img/countryflag/world-icon.png"  class="h-10" *ngIf="!currCountry">
                        </div>

                        <form>

                            <mat-form-field fxFlex floatLabel="never">

                                <input matInput autocomplete="off" placeholder="Choisissez un pays" [matAutocomplete]="auto" [formControl]="countryCtrl">

                                <mat-autocomplete #auto="matAutocomplete">

                                    <ng-container *ngIf="filteredCountries">

                                        <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name" (onSelectionChange)="setCurrCosts(country)">

                                            <div fxLayout="row" fxLayoutGap="10px">
                                                <div fxLayoutAlign="center center">
                                                    <img src="data:image/png;base64,{{country.flag}}"  class="h-4">
                                                </div>
                                                <div fxLayoutAlign="center center">
                                                    <span>{{country.name}}</span>
                                                </div>
                                            </div>

                                        </mat-option>

                                    </ng-container>

                                    <mat-option *ngIf="!filteredCountries">
                                        <span>{{'WeightsTableComponent.noResult'|translate}} </span>
                                    </mat-option>

                                </mat-autocomplete>

                            </mat-form-field>

                        </form>

                    </div>

                    <table mat-table [dataSource]="currCosts" class="full-w" *ngIf="currCosts" class="bordered-card">

                        <!-- Weight Column -->
                        <ng-container matColumnDef="max_weight">
                            <th mat-header-cell *matHeaderCellDef>{{'WeightsTableComponent.weight'|translate}}  </th>
                            <td mat-cell *matCellDef="let costData">{{'WeightsTableComponent.until'|translate}}  <strong>{{costData.max_weight}}kg</strong></td>
                        </ng-container>

                        <!-- Shipping price Column -->
                        <ng-container matColumnDef="shipping_price">
                            <th mat-header-cell *matHeaderCellDef>{{'WeightsTableComponent.price'|translate}} </th>
                            <td mat-cell *matCellDef="let costData">{{costData.shipping_price | priceFilter}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                </div>

            </mat-tab>

        </mat-tab-group>

    </div>

    <div class="layout-padd" style="padding-top: 0;">
        <button mat-stroked-button fxFlex (click)="closeDial()" angulartics2On="click" angularticsAction="closeEligibleCitiesDial" angularticsCategory="order">
    <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
  </button>
    </div>

</div>
